import React from 'react';
import Navbar1 from '../../Navbar/Navbar1/Navbar1';
import Footer from '../../Footer/Footer';
import './Services3.css';
import { FaCheckCircle, FaShieldAlt, FaClock, FaRobot, FaCertificate, FaRocket, FaEye } from 'react-icons/fa';

const Services3 = ({ onNavigate }) => {
  return (
    <>
      <Navbar1 onNavigate={onNavigate} />
      <div className="services3-hero">
        <p className="services3-top">Your Fleetwide Emissions Reporting & Compliance Platform</p>
        <h1 className="services3-title">Shipshape Carbon</h1>
        <p className="services3-description">
          An intelligent emissions reporting and compliance platform, purpose-built for modern maritime fleets
          navigating an increasingly complex regulatory environment.
        </p>
                  <button className="services3-btn" onClick={() => onNavigate('contact')}>Book Demo</button>

        <div className="services3-info-boxes">
          <div className="services3-info">
            <h4>Real-Time Insights</h4>
            <p>Live CII scoring and emissions tracking as voyages unfold</p>
          </div>
          <div className="services3-info">
            <h4>Automated Compliance</h4>
            <p>Class-ready reports for MRV, DCS, CII, FuelEU</p>
          </div>
          <div className="services3-info">
            <h4>Fleet-Wide Visibility</h4>
            <p>Unified dashboard across all vessels and compliance parameters</p>
          </div>
        </div>
      </div>


      <div className="services3-covered-section">
        <h2 className="services3-covered-title">What You're Covered For</h2>
        <p className="services3-covered-subtext">
            Shipshape Carbon ensures full alignment with global and regional emissions regulations
        </p>

        <div className="services3-covered-grid">
            <div className="covered-card">
            <span className="active-badge">Active</span>
            <h4>IMO DCS & CII</h4>
            <p>MARPOL Annex VI compliance</p>
            </div>
            <div className="covered-card">
            <span className="active-badge">Active</span>
            <h4>EU MRV</h4>
            <p>Regulation 2015/757</p>
            </div>
            <div className="covered-card">
            <span className="active-badge">Active</span>
            <h4>FuelEU Maritime</h4>
            <p>Coming into force 2025</p>
            </div>
            <div className="covered-card">
            <span className="active-badge">Active</span>
            <h4>UK MRV</h4>
            <p>Post-Brexit compliance framework</p>
            </div>
        </div>

        <div className="charterer-box">
            <div className="charterer-header">
            <FaCheckCircle className="charterer-icon" />

            <h4>Charterer-Specific Templates</h4>
            </div>
            <p className="charterer-subtext">
            Pre-configured templates for major charterers and industry standards
            </p>
            <div className="charterer-tags">
            {['Shell', 'BP', 'OCIMF', 'ExxonMobil', 'TotalEnergies', 'Chevron'].map(name => (
                <span className="charterer-tag" key={name}>{name}</span>
            ))}
            </div>
        </div>

        <p className="services3-covered-footnote">
            Whether you're submitting verified data, planning voyages to avoid derating, or comparing ship performance across the fleet —
            <span className="audit-bold"> you're always audit-ready.</span>
        </p>
        </div>


        <section className="key-platform-capabilities">
  <div className="container">
    <h2 className="kpc-title">Key Platform Capabilities</h2>
    <p className="kpc-subtitle">
      Transform emissions management from a reporting burden into an operational advantage
    </p>

    <div className="kpc-table">
      <div className="kpc-header">
        <p className="header-title">Platform Capabilities Overview</p>
      </div>

      <div className="kpc-row kpc-labels">
        <p className="kpc-col kpc-col-left"><strong>Capability</strong></p>
        <p className="kpc-col kpc-col-right"><strong>What It Means for You</strong></p>
      </div>

      <div className="kpc-row">
        <p className="kpc-col kpc-col-left">Automated Compliance Reporting</p>
        <p className="kpc-col kpc-col-right">Class-ready reports for MRV, DCS, CII, FuelEU — no spreadsheets required</p>
      </div>

      <div className="kpc-row">
        <p className="kpc-col kpc-col-left">Live CII Scoring & Projection</p>
        <p className="kpc-col kpc-col-right">View real-time impact of each voyage on your annual CII rating</p>
      </div>

      <div className="kpc-row">
        <p className="kpc-col kpc-col-left">FuelEU Intensity Forecasting</p>
        <p className="kpc-col kpc-col-right">Simulate voyage-specific carbon intensity and detect risk of non-compliance</p>
      </div>

      <div className="kpc-row">
        <p className="kpc-col kpc-col-left">Fleet-Wide Emissions Dashboard</p>
        <p className="kpc-col kpc-col-right">Unify visibility across all vessels, routes, and compliance parameters</p>
      </div>

      <div className="kpc-row">
        <p className="kpc-col kpc-col-left">Deviation & Alert System</p>
        <p className="kpc-col kpc-col-right">Get notified of emissions spikes or thresholds before penalties occur</p>
      </div>

      <div className="kpc-row">
        <p className="kpc-col kpc-col-left">Audit-Ready Recordkeeping</p>
        <p className="kpc-col kpc-col-right">Timestamped, standardised logs available for authority or class inspections</p>
      </div>
    </div>
  </div>
</section>


{/* <div className="fi-section">
  <p className="fi-tagline">Powered by the Shipshape Ecosystem</p>
  <h2 className="fi-heading">Fully Integrated Operational Intelligence</h2>
  <p className="fi-subtext">
    Shipshape Carbon is not just another reporting tool — it’s part of a fully integrated operational intelligence system
  </p>

  <div className="fi-card-container">
    <div className="fi-card">
      <span className="fi-label">Onboard Data Collection</span>
      <h4>Shipshape Chief</h4>
      <p>
        Onboard module that collects high-frequency engine, fuel, and cargo data — transforming your vessel into a connected, digital twin.
      </p>
    </div>
    <div className="fi-card">
      <span className="fi-label">Voyage Optimization</span>
      <h4>Shipshape Captain</h4>
      <p>
        Voyage optimisation engine that models CII impact, simulates FuelEU emissions intensity, and recommends compliance-safe routing and speeds.
      </p>
    </div>
    <div className="fi-card">
      <span className="fi-label">Fleet Intelligence</span>
      <h4>Shipshape IQ</h4>
      <p>
        The central dashboard unifying emissions, fuel, maintenance, and performance modules into a real-time intelligence platform for shore teams.
      </p>
    </div>
  </div>
</div> */}

<div className="fi-section">
  <p className="fi-tagline">Powered by the Shipshape Ecosystem</p>
  <h2 className="fi-heading">Fully Integrated Operational Intelligence</h2>
  <p className="fi-subtext">
    Shipshape Carbon is more than a reporting platform—it is part of a unified operational intelligence ecosystem that transforms maritime data into actionable insights.
  </p>

  <div className="fi-card-container">
    <div className="fi-card">
      <span className="fi-label">Data Intelligence</span>
      <h4>Shipshape Chief</h4>
      <p>
      A centralized data intelligence layer that consolidates operational, voyage, fuel, and emissions data into a unified foundation for analytics, compliance, and performance optimization.
      </p>
    </div>
    <div className="fi-card">
      <span className="fi-label">Voyage Optimization</span>
      <h4>Shipshape Captain</h4>
      <p>
      Voyage optimization capabilities that analyze CII impact, evaluate FuelEU emissions intensity, and recommend compliance-focused routing and operational strategies.
      </p>
    </div>
    <div className="fi-card">
      <span className="fi-label">Fleet Intelligence</span>
      <h4>Shipshape IQ</h4>
      <p>
      A centralized intelligence platform that unifies emissions, fuel, maintenance, and performance insights to support informed decision-making across fleet operations.
      </p>
    </div>
  </div>
</div>



<div className="emissions-intel-section">
  <div className="emissions-intel-header">
    <h3>Real-Time Emissions Intelligence</h3>
    <p>
      Together, they enable Shipshape Carbon to deliver real-time emissions intelligence, risk avoidance, and seamless regulatory output at scale.
    </p>
  </div>

  <div className="emissions-intel-grid">
    <div className="emissions-left-card">
      <h4>Integration & Deployment</h4>
      <ul>
        <li><span>✔</span> Compatible with all major engine and fuel monitoring systems</li>
        <li><span>✔</span> Cloud-based or hybrid deployment</li>
        <li><span>✔</span> API-ready for integration with existing fleet management systems</li>
        <li><span>✔</span> Modular design — can be activated as standalone or part of full Shipshape suite</li>
      </ul>
    </div>

    <div className="emissions-right-card">
      <span className="emissions-tag">Transformation</span>
      <h4>From Reactive Reporting to Proactive Readiness</h4>
      <p>
        With Shipshape Carbon, your compliance teams don't just report on emissions — they anticipate them, manage them, and reduce them. From daily voyage visibility to annual class submissions, the entire emissions lifecycle is covered.
      </p>
    </div>
  </div>
</div>


<div className="why-Shipshape-section">
  <h2>Why Choose Shipshape Carbon</h2>
  <p>Built specifically for maritime emissions compliance</p>

  <div className="why-Shipshape-grid">
    <div className="why-card">
      <div className="why-card-icon">
        <FaShieldAlt />
      </div>
      <h4>Built for Regulation</h4>
      <p>Not a retrofit — this is compliance by design</p>
    </div>
    <div className="why-card">
      <div className="why-card-icon">
        <FaClock />
      </div>
      <h4>Real-Time Precision</h4>
      <p>Get insights as voyages unfold, not weeks later</p>
    </div>
    <div className="why-card">
      <div className="why-card-icon">
        <FaRobot />
      </div>
      <h4>Zero Manual Input</h4>
      <p>Automated reporting reduces error and saves time</p>
    </div>
    <div className="why-card">
      <div className="why-card-icon">
        <FaCertificate />
      </div>
      <h4>Class & Authority Ready</h4>
      <p>Outputs fully aligned with regulatory formats</p>
    </div>
    <div className="why-card">
      <div className="why-card-icon">
        <FaRocket />
      </div>
      <h4>Scalable & Future-Proof</h4>
      <p>Ready for FuelEU and other upcoming mandates</p>
    </div>
    <div className="why-card">
      <div className="why-card-icon">
        <FaEye />
      </div>
      <h4>One Interface, Total Clarity</h4>
      <p>Shipshape IQ brings it all together</p>
    </div>
  </div>
</div>

<div className="carbon-compliance-section">
  <h2>Let's Talk Carbon Compliance</h2>
  <p>
    Whether you're preparing for FuelEU, navigating CII risk, or scaling ESG reporting, 
    Shipshape Carbon puts you in control.
  </p>
              <button className="schedule-btn" onClick={() => onNavigate('contact')}>Schedule Demo</button>
</div>


      <Footer onNavigate={onNavigate} />
    </>
  );
};

export default Services3;
